import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import { Status } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";

class MasterSuppliersFilter extends Component {
  statusOptions = [
    {
      label: Status.ACTIVE,
      value: Status.ACTIVE,
    },
    {
      label: Status.INACTIVE,
      value: Status.INACTIVE,
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
      jenisSupplierOptions: [],
    };
  }

  async componentDidMount() {
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang(),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "SUPPLIER_TYPE",
        },
      }),
    ]);

    if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        cabangOptions: responses[0].data.data.map((c) =>
          mapToObjectDDL(c.namaDealer, c.kodeCabang)
        ),
      }));
    }

    if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        jenisSupplierOptions: responses[1].data.data.map((option) =>
          mapToObjectDDL(option.value, option.key)
        ),
      }));
    }
  }

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  getFilterDataValue(fieldName, fallbackValue = "") {
    return !R.isNil(this.props.data) && this.props.data[fieldName]
      ? this.props.data[fieldName]
      : fallbackValue;
  }

  render() {
    return (
      <SimpleModal
        title="Filter"
        visible={this.props.visible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
              <SimpleInput
                id="input_text_kode_supplier"
                name="kodeSupplier"
                label="Kode Supplier"
                value={this.getFilterDataValue("kodeSupplier")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_nama_supplier"
                name="namaSupplier"
                label="Nama Supplier"
                value={this.getFilterDataValue("namaSupplier")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_alamat"
                name="alamat"
                label="Alamat"
                value={this.getFilterDataValue("alamat")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_email"
                name="email"
                label="Email"
                value={this.getFilterDataValue("email")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_jenis_supplier"
                name="jenisSupplier"
                label="Jenis Supplier"
                box="search"
                isClearable
                options={this.state.jenisSupplierOptions}
                value={this.getFilterDataValue("jenisSupplier", null)}
                onChange={(value, { name }) =>
                  this.handleValueChange(name, value)
                }
              />
              <SimpleInput
                id="input_text_nama_pic"
                name="namaPic"
                label="Nama PIC"
                value={this.getFilterDataValue("namaPic")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_telepon"
                name="telepon"
                label="Telepon"
                box="onlyNumber"
                maxLength={14}
                value={this.getFilterDataValue("telepon")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_jabatan"
                name="jabatan"
                label="Jabatan"
                value={this.getFilterDataValue("jabatan")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_cabang"
                name="cabang"
                label="Cabang"
                box="multiselect"
                isClearable
                options={this.state.cabangOptions}
                value={
                  (!R.isNil(this.props.data) && this.props.data.cabang) || []
                }
                onChange={(value, { name }) =>
                  this.handleValueChange(name, value)
                }
              />
              <SimpleDDL
                id="select_options_status"
                name="status"
                label="Status"
                box="search"
                isClearable
                options={this.statusOptions}
                value={
                  !R.isNil(this.props.data) && this.props.data.status
                    ? this.props.data.status
                    : { label: Status.ACTIVE, value: Status.ACTIVE }
                }
                onChange={(value, { name }) =>
                  this.handleValueChange(name, value)
                }
              />
              <FlexView hAlignContent="right">
                <SimpleButton
                  type="button"
                  secondary
                  onClick={this.props.onReset}
                >
                  Hapus
                </SimpleButton>
                <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
              </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default MasterSuppliersFilter;
